import React from "react";
import PropTypes from "prop-types";

import css from "./FeatureImageHeaderContent.module.scss";
import ArticleTags from "components/ArticleTags";
import Icon from "components/Icon";
import AnimateOpacity from "components/ParallaxAnimation/AnimateOpacity";
import Button from "components/Button";
import CuriousBlock from 'components/CuriousBlock';
import PublishedDate from 'components/PublishedDate';
import cn from 'classnames';

import FitText from "components/FitText/FitText";

const getAnimationData = shouldAnimate => {
    if (!shouldAnimate) return {};
    return {
        textAnimationData: { start: 100, end: 250 },
        bylineAnimationData: { start: 250, end: 400 },
        iconAnimationData: { start: 300, end: 360, hide: true }
    };
};

const FeatureImageHeaderContent = ({
    tags,
    title,
    text,
    bylines,
    showIcon,
    shouldAnimate,
    icon,
    isLandingPage,
    buttonText,
    buttonUrl,
    curious,
    publishedDate
}) => {
    const {
        textAnimationData,
        bylineAnimationData,
        iconAnimationData,
    } = getAnimationData(shouldAnimate);

    return (
       
        <div className={cn(css.featureImageHeaderContent, {
            [css.isLandingPage]: isLandingPage
        })}>
            <div>
                {tags && <ArticleTags tags={tags} icon={icon} />}
                {title && <h1 className={css.title}><FitText text={title} /></h1>}
                <AnimateOpacity {...textAnimationData} className={css.invisible}>

                    <p className={css.text}>{text}</p>
                </AnimateOpacity>
                {bylines && bylines.length && (
                    <AnimateOpacity
                        {...bylineAnimationData}
                        className={css.invisible}
                    >
                        <div className={css.bylines}>
                            {bylines.map(byline => (
                                <div key={byline.text}>
                                    {byline.type && <b className={css.bylineType}>{byline.type}</b> }
                                    <span>{byline.text}</span>
                                </div>
                            ))}
                        </div>
                    </AnimateOpacity>
                )} 
                {publishedDate && 
                <AnimateOpacity {...bylineAnimationData} className={css.invisible}>
                    <PublishedDate className={css.date} {...publishedDate} />
                </AnimateOpacity>
                }
                {isLandingPage && 
                            <div className={css.button}>
                                <Button tertiary href={buttonUrl}>{buttonText}</Button>
                            </div>
                }
                {showIcon && (
                    <AnimateOpacity {...iconAnimationData}>
                        <div className={css.iconWrapper}>
                            <Icon icon="arrow-down" className={css.icon} />
                        </div>
                    </AnimateOpacity>
                )}
                {curious && curious.text && (
                    <CuriousBlock {...curious} className={css.curious} />
                )}
            </div>
        </div>
    );
};

FeatureImageHeaderContent.propTypes = {
    tags: PropTypes.string,
    icon: PropTypes.string,
    title: PropTypes.string,
    text: PropTypes.string,
    bylines: PropTypes.array,
    showIcon: PropTypes.bool,
    shouldAnimate: PropTypes.bool,
    isLandingPage: PropTypes.bool,
    buttonText: PropTypes.string,
    buttonUrl: PropTypes.string,
    curious: CuriousBlock.propTypes,
    publishedDate: PropTypes.shape(PublishedDate.propTypes)
};

export default FeatureImageHeaderContent;



// WEBPACK FOOTER //
// ./src/components/FeatureImageHeaderContent/FeatureImageHeaderContent.jsx